import { NOTICIAS_BANNER, appEnv } from "../../../utils/Constants.tsx";
import "./appInfoBar.css";

// Latest release published in the "novedades" list (first item)
const VERSION: string | undefined = NOTICIAS_BANNER[0]?.version;

/**
 * Slim bar at the top of the content area (right box): ownership notice,
 * version and a visible tag in development (same condition that points the API to
 * localhost in Constants.tsx) so test data is never mistaken for real.
 */
export default function AppInfoBar() {
  const anio = new Date().getFullYear();
  const esDesarrollo = appEnv === "development";

  return (
    <div
      className="app-infobar"
      role="note"
      aria-label="Información de FishWeb"
    >
      <div className="app-infobar-marca">
        <span className="app-infobar-logo" aria-hidden="true">
          <i className="pi pi-box" />
        </span>
        <span className="app-infobar-nombre">
          FishWeb <span className="app-infobar-copy">© {anio}</span>
        </span>
        <span className="app-infobar-sep" aria-hidden="true" />
        <span className="app-infobar-texto">
          ERP de Licencia Propia
          <span className="app-infobar-punto" aria-hidden="true">
            ·
          </span>
          Activo Empresarial
        </span>
      </div>

      <div className="app-infobar-meta">
        {esDesarrollo ? (
          <span
            className="app-infobar-chip app-infobar-chip-env"
            title="API local (localhost): no es el ambiente productivo"
          >
            <i className="pi pi-wrench" aria-hidden="true" /> Desarrollo
          </span>
        ) : null}
        {VERSION ? (
          <span className="app-infobar-chip" title="Versión publicada">
            <i className="pi pi-tag" aria-hidden="true" /> {VERSION}
          </span>
        ) : null}
      </div>
    </div>
  );
}
